import { useEffect, useRef } from 'react';

export const useLazyLoadList = <T extends Element>(loadMore: () => void) => {
    const targetRef = useRef<T>(null);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (targetRef.current) {
            const observer = new IntersectionObserver(
                (entries) =>
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            loadMore();
                            observer.disconnect();
                        }
                    }),
                { rootMargin: '0px 0px 50px 0px' },
            );
            observer.observe(targetRef.current);

            return () => observer && observer.disconnect();
        }
    }, [loadMore]);

    return targetRef;
};
